import {
  types,
  IEditorsPerGroupParams,
  IGroupEditorsState,
  IGetGroupEditorsAction,
  IGetGroupEditorsSuccessAction,
  IGetGroupEditorsFailureAction,
  IInvalidateGroupEditorsAction,
} from '../types/editorsPerGroup'

export const getGroupEditors = (
  groupId: string,
  params?: IEditorsPerGroupParams
): IGetGroupEditorsAction => ({
  type: types.GET_GROUP_EDITORS__STARTED,
  groupId,
  params,
})

export const getGroupEditorsSuccess = (
  groupId: string,
  editorsData: IGroupEditorsState
): IGetGroupEditorsSuccessAction => ({
  type: types.GET_GROUP_EDITORS__SUCCESS,
  groupId,
  editorsData,
})

export const getGroupEditorsFailure = (
  message: string,
  groupId: string,
  editorsData: IGroupEditorsState
): IGetGroupEditorsFailureAction => ({
  type: types.GET_GROUP_EDITORS__FAILURE,
  message,
  groupId,
  editorsData,
})

export const invalidateGroupEditors = (
  groupId: string
): IInvalidateGroupEditorsAction => ({
  type: types.INVALIDATE_GROUP_EDITORS,
  groupId,
})
